export default {
  REFRESH_SUCCESS: 'Refresh success',
  REFRESH_FAILED_AND_TIP: 'Refresh failed: No parameter of current map'
}
